/** Default UI filter state — map to API params in each page via fclReportHelpers */

export const defaultDateRangeFilters = () => {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - 30);
    return {
        FromDate: start.toISOString().split("T")[0],
        ToDate: end.toISOString().split("T")[0],
    };
};

export const defaultExportBookingFilters = () => ({
    ...defaultDateRangeFilters(),
    ReportBy: "ETS",
});

export const defaultExportSalespersonFilters = () => ({
    ...defaultExportBookingFilters(),
    SalesPersonId: "",
});

export const defaultImportEtsEtaFilters = () => ({
    ...defaultDateRangeFilters(),
    ReportBy: "ETS",
});

export const defaultImportActiveShipmentFilters = () => ({
    ...defaultDateRangeFilters(),
    ReportBy: "ETS",
});

export const defaultImportTruckingFilters = () => ({
    ...defaultDateRangeFilters(),
    ReportBy: "ETS",
});

export const defaultImportStatusAuditFilters = () => ({
    ...defaultDateRangeFilters(),
    ReportBy: "ETS",
});

export const defaultImportContainerTrackingFilters = () => ({
    ...defaultDateRangeFilters(),
    ReportBy: "ETS",
    IPageNo: 1,
    IPageRecords: 25,
});

export const defaultImportArrivalNoticeFilters = () => ({
    ...defaultDateRangeFilters(),
    ReportBy: "ETS",
});

export const defaultImportEtaStatusFilters = () => ({
    ...defaultDateRangeFilters(),
});

export const defaultImportFileCancellationFilters = () => ({
    ...defaultDateRangeFilters(),
    ReportBy: "ETS",
});

export const defaultImportArrivalNoticePreAlertFilters = () => ({
    ...defaultDateRangeFilters(),
    ReportBy: "ETA",
});
